import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function PressureServiceFormation() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO SECTION ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Formation Académique</h1>
            <p>
              Nos formations techniques et réglementaires visent à renforcer les
              compétences des professionnels du contrôle, de la maintenance et de
              la sécurité industrielle. Elles couvrent l’ensemble des étapes de
              l’inspection, de la compréhension des normes à la maîtrise des
              rapports d’audit.
            </p>

            <div className="prs-hero__bullets">
              <span>➜ Normes & conformité</span>
              <span>➜ Méthodes d’inspection</span>
              <span>➜ Rédaction de rapports & suivi</span>
            </div>

            <a href="#contact" className="btn-primary">
              Demander un devis
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/formation/1.jpg" alt="Inspection en atelier" /></div>
              <div><img src="/images/formation/2.jpg" alt="Épreuve hydraulique" /></div>
              <div><img src="/images/formation/3.jpg" alt="Réservoir sous pression" /></div>
              <div><img src="/images/formation/4.jpg" alt="Contrôle visuel" /></div>
              <div><img src="/images/formation/5.jpg" alt="Sécurité des installations" /></div>
              <div><img src="/images/formation/6.jpg" alt="Maintenance et conformité" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== SECTION FORMATION DETAIL ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Objectif de la formation</h2>
          <p>
            Cette formation a pour but de permettre aux participants de
            <strong> comprendre et appliquer la réglementation marocaine et internationale </strong>
            relative aux appareils à pression et de levage, de
            <strong> maîtriser les méthodes d’inspection</strong> et d’assurer
            une <strong>traçabilité documentaire conforme aux exigences légales</strong>.
          </p>

          <h3>Compétences développées</h3>
          <ul>
            <li>Identifier les textes réglementaires applicables et leurs évolutions.</li>
            <li>Analyser les risques liés à la non-conformité d’un équipement.</li>
            <li>Effectuer un contrôle visuel, dimensionnel et fonctionnel complet.</li>
            <li>Rédiger un rapport technique d’inspection structuré et exploitable.</li>
            <li>Planifier les visites périodiques et le suivi des interventions.</li>
          </ul>

          <h3>Programme de la formation</h3>
          <ul>
            <li><strong>Jour 1 :</strong> Introduction à la réglementation, Code du travail et normes EN/ISO.</li>
            <li><strong>Jour 2 :</strong> Méthodologie de contrôle visuel et essais statiques/dynamiques.</li>
            <li><strong>Jour 3 :</strong> Études de cas pratiques, rédaction des rapports et gestion documentaire.</li>
          </ul>

          <h3>Méthodes pédagogiques</h3>
          <p>
            Alternance entre <strong>exposés théoriques</strong>, <strong>démonstrations pratiques</strong> 
            en atelier et <strong>évaluations interactives</strong> sur cas réels d’inspection.  
            Chaque stagiaire manipule des outils de contrôle et apprend à interpréter les résultats.
          </p>

          <h3>Public concerné</h3>
          <p>
            Techniciens de maintenance, ingénieurs sécurité, responsables HSE, inspecteurs agréés,
            et toute personne souhaitant se spécialiser dans les <strong>contrôles réglementaires
            des équipements industriels</strong>.
          </p>

          <h3>Durée et certification</h3>
          <p>
            Durée standard : <strong>3 jours (21 heures)</strong> – adaptable selon le profil et les besoins du client.  
            Une <strong>attestation de formation</strong> est délivrée à l’issue de l’évaluation finale.
          </p>

          <h3>Supports et documentation fournis</h3>
          <ul>
            <li>Manuel complet de la formation (PDF + support papier).</li>
            <li>Fiches d’inspection type et modèles de rapports officiels.</li>
            
          </ul>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
